export const apiCreate = (): string => '/financial/fiscalSettings/'
export const apiList = (id?: string): string =>
  !id ? '/financial/fiscalSettings/' : `/financial/fiscalSettings/view/${id}`
export const apiUpdate = (id: string): string =>
  `/financial/fiscalSettings/update/${id}`
export const apiDelete = (id: string): string =>
  `/financial/fiscalSettings/${id}`
